import { tap } from 'rxjs/operators'
import { reduce as _reduce, mapValues as _mapValues } from 'lodash-es'
import { serviceHierarhcyService } from '../../service/service-hierarchy-service'
import { calculationService } from '../../service/calculation-service'
import { parseServiceName } from '../../common/service-name-utils'

export const namespace = 'SERVICE_HIERARCHY'

export const types = {
  GET_SERVICE_GNB_HIERARCHY: 'getServiceGnbHierarchy',
  SET_SERVICE_GNB_HIERARCHY: 'setServiceGnbHierarchy',
  GET_SERVICE_MAIN_HIERARCHY_LIST: 'getServiceMainHierarchyList',
  SET_SERVICE_MAIN_HIERARCHY_LIST: 'setServiceMainHierarchyList',
  GET_SERVICE_LNB_HIERARCHY_LIST: 'getServiceLnbHierarchyList',
  GET_SERVICE_LNB_CATEGORY_MAP: 'getServiceLnbCategoryMap',
  SET_SERVICE_LNB_HIERARCHY_LIST: 'setServiceLnbHierarchyList',
  GET_SERVICE_OVERVIEW_HIERARCHY_LIST: 'getServiceOverviewHierarchyList',
  SET_SERVICE_OVERVIEW_HIERARCHY_LIST: 'setServiceOverviewHierarchyList',
  GET_CALCULATION_LNB_HIERARCHY_LIST: 'getCalculationLnbHierarchyList',
  SET_CALCULATION_LNB_HIERARCHY_LIST: 'setCalculationLnbHierarchyList',
  GET_MARKETPLACE_LNB_HIERARCHY_LIST: 'getMarketPlaceLnbHierarchyList',
  SET_MARKETPLACE_LNB_HIERARCHY_LIST: 'setMarketPlaceLnbHierarchyList'
}

const state = {
  serviceGnbHierarchy: {
    projectServices: [],
    orgServices: []
  },
  serviceMainHierarchyList: [],
  serviceLnbHierarchyList: [],
  serviceOverviewHierarchy: {
    projectServices: [],
    orgServices: []
  },
  calculationLnbHierarchyList: []
}

const getters = {
  // parent_product_ui_name to category
  [types.GET_SERVICE_LNB_CATEGORY_MAP]: state => {
    const flattenCategories = _reduce(
      state.calculationLnbHierarchyList,
      (result, category) => {
        const parsedCategoryName = parseServiceName(category.name)
        const services = _mapValues(category.services, service => {
          service['parsedServiceName'] = parseServiceName(service.name)
          service['parsedParentServiceName'] = parsedCategoryName
          service['parentServiceName'] = category.name
          return service
        })
        result[parsedCategoryName] = {
          ...category,
          services
        }
        return result
      },
      {}
    )
    return flattenCategories
  }
}

const mutations = {
  [types.SET_SERVICE_GNB_HIERARCHY](state, payload) {
    state.serviceGnbHierarchy = payload
  },
  [types.SET_SERVICE_MAIN_HIERARCHY_LIST](state, payload) {
    state.serviceMainHierarchyList = payload
  },
  [types.SET_SERVICE_LNB_HIERARCHY_LIST](state, payload) {
    state.serviceLnbHierarchyList = payload
  },
  [types.SET_SERVICE_OVERVIEW_HIERARCHY_LIST](state, payload) {
    state.serviceOverviewHierarchy = payload
  },
  [types.SET_CALCULATION_LNB_HIERARCHY_LIST](state, lnbHierarchyList) {
    state.calculationLnbHierarchyList = lnbHierarchyList
  }
}

const actions = {
  [types.GET_SERVICE_GNB_HIERARCHY]({ commit }) {
    serviceHierarhcyService.getServiceGnbHierarchy$().subscribe(hierarchy => {
      commit(types.SET_SERVICE_GNB_HIERARCHY, hierarchy)
    })
  },
  [types.GET_SERVICE_MAIN_HIERARCHY_LIST]({ commit }) {
    serviceHierarhcyService.getServiceMainHierarchyList$().subscribe(hierarchyList => {
      commit(types.SET_SERVICE_MAIN_HIERARCHY_LIST, hierarchyList)
    })
  },
  [types.GET_SERVICE_LNB_HIERARCHY_LIST]({ commit }) {
    return serviceHierarhcyService
      .getServiceLnbHierarchyList$()
      .pipe(
        tap(hierarchyList => {
          commit(types.SET_SERVICE_LNB_HIERARCHY_LIST, hierarchyList)
        })
      )
      .toPromise()
  },
  [types.GET_SERVICE_OVERVIEW_HIERARCHY_LIST]({ commit }) {
    serviceHierarhcyService.getServiceOverviewHierarchyList$().subscribe(hierarchy => {
      commit(types.SET_SERVICE_OVERVIEW_HIERARCHY_LIST, hierarchy)
    })
  },
  [types.GET_CALCULATION_LNB_HIERARCHY_LIST]({ commit }) {
    return calculationService
      .getLnbHierarchyList$()
      .pipe(
        tap(hierarchyList => {
          commit(types.SET_CALCULATION_LNB_HIERARCHY_LIST, hierarchyList)
        })
      )
      .toPromise()
  }
}

export const serviceHierarchyStore = {
  state,
  mutations,
  getters,
  actions,
  namespace,
  types
}
